<template>
<div class="content">

    <!-- header -->
    <div v-if="mobileShow && false" class="header">
        <div class="header-middle public_width clearfix">
            <div class="content-left">
                <span class="header-add secondary_text ">欢迎访问国联质量检测技术股份有限公司</span>
                <span class="header-add secondary_text padding-left-distance"> 24小时全国服务热线 400-800-1252</span>
            </div>
            <div class="content-right">
                <a class="secondary_text header-content-right-item " :href="'/queryOrder'">
                    订单及报告查询
                </a>
                <a class="secondary_text header-content-right-item  padding-left20px"  @click="navto"  >
                    报告验证
                </a>
                <!-- <span class="header-add secondary_text" v-for="(item,index) in NavList" @click="tonavlist(item)" style="cursor: pointer !important;" :key="index">{{item.name}}</span>
                <el-dropdown placement="bottom" @command="commandChange">
                    <span class="el-dropdown-link header-add secondary_text">
                        国联全站
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="index" v-for="(item,index) in urllist" :key="index">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
        </div>
    </div>
    <div class="container-style"  style="min-height:900px;">
        <!-- 所有路由的总出口 -->
        <router-view></router-view>
    </div>
    <!-- <leftTool ref="leftTool" /> -->
    <homeFooter ref="homeFooter" v-if="homeFooterShow" />
</div>
</template>

<script>
import homeFooter from '@/components/homeFooter';
// import leftTool from "@/components/leftTool";
import { mapState, mapMutations } from 'vuex'
export default {
    name: "homeHeader",
    components: {
        homeFooter: homeFooter,
        // leftTool: leftTool,
    },
    computed: {
        ...mapState(['screenWidth']),
        mobileShow() {
        if (this.screenWidth < 1000) {
            return false
        } else {
            return true
        }
        }
    },
    data() {
        return {
            search: "",
            urllist: [],
            NavList: [{
                    path: "http://glpc.xaunqd.com/verification/index.html",
                    name: "报告验证"
                },
                {
                    name: '|'
                },
                {
                    path: "/contact",
                    name: "联系我们"
                },
                {
                    name: '|'
                },
            ],
            homeFooterShow: true
        };
    },
    created() {
        if(window.location.href.indexOf('jinZhiCertification') > -1) {
            this.homeFooterShow = false
        } else {
            this.homeFooterShow = true
        }
        // this.$api.iotHome.friendLink({}).then(res => {
        //     if (res.data.success == true) {
        //         // res.data.data = res.data.data.reverse();
        //         this.urllist = res.data.data;
        //     }
        // })
        this.$api.iotHome.getSite({
            siteType: "0",
            type: "0"
        }).then(res => {
            if (res.data.success == true) {
                window.localStorage.setItem('siteData', JSON.stringify(res.data.data));
            }
        })
    },
    methods: {
        navto(){
            window.open('http://glpc.xaunqd.com/verification/index.html')
        },
        navigateTo(url){
            // eslint-disable-next-line no-console
            console.log(url)
            this.$router.push({path:`${url}`})
        },
        commandChange(val) {
            var url = this.urllist[val].url;
            window.open(url, '__target__');
        },
        tonavlist(data) {
            window.open(data.path,'__target1__');
            // if (data.path) {
            //     this.$router.push({
            //         path: data.path,
            //         query: {
            //             toDetailStatus: 1,
            //         }
            //     });
            // }
        },
    }
};
</script>

<style lang="scss" scoped>

.content {
    .header {
        width: 100%;
        background-color: #F5F6F9;
        height: 36px;
        line-height: 36px;
        margin-bottom: 28px;
        display: flex;
        align-items: center;

        .header-middle {
            font-size: 14px;
            .padding-left-distance{
                padding-left: 20px;
            }
            .content-left {
                float: left;
                align-items: center;
                justify-content: center;
                display: flex;
                flex-direction: row;
            }
            .content-right {
                float: right;
                align-items: center;
                justify-content: center;
                display: flex;
                flex-direction: row;

                .header-add {
                    cursor: default;
                }
                .header-content-right-item:hover{
                    color: #122266;
                }
            }
        }
    }
}
</style>
